@if (inView()) {
    <div
        class="st-live-card-item-border-left"
        st-left-border
        [data]="data()"></div>
}
@switch (cardViewType()) {
    @case (CardViewTypes.SMALL) {
        <ng-container *ngTemplateOutlet="smallCard" />
    }
    @case (CardViewTypes.LARGE) {
        <ng-container *ngTemplateOutlet="largeCard" />
    }
    <!-- @case (CardViewTypes.MEDIUM) {
  <ng-container *ngTemplateOutlet="mediumCard" />
  } -->
    @default {
        <ng-container *ngTemplateOutlet="largeCard" />
    }
}
<ng-template #smallCard>
    @if (inView()) {
        <div class="st-live-card-item-container__mobile">
            <div class="st-live-card-item-container__mobile--top-row">
                <div class="st-live-card-item-container__mobile--rundown">{{ languageSettings()?.PSTObjectTypeRundown }}</div>
                @if (isArchived()) {
                    <div class="st-live-card-item-container__mobile--archived">{{ archivedLabel() }}</div>
                }
            </div>
            <div class="st-live-card-item-container__mobile--slug">
                {{ data()?.Title }}
            </div>
            <div class="st-live-card-item-container__mobile__data">
                <div>
                    <div class="st-live-card-item-container__mobile--dates">
                        <span>{{ languageSettings()?.PSTWebStartsLabel }}: {{ startTime() }}</span>
                        <span>{{ languageSettings()?.PSTWebEndsLabel }}: {{ endTime() }}</span>
                    </div>
                </div>
                <div class="st-live-card-item-container__mobile--info">
                    <mat-icon
                        [class.st-live-card-item-container__mobile--info--approved]="data()?.OnAir"
                        [class.material-symbols-outlined]="!data()?.OnAir">
                        movie
                    </mat-icon>
                    <mat-icon
                        [class.st-live-card-item-container__mobile--info--approved]="data()?.MosControl"
                        [class.material-symbols-outlined]="!data()?.MosControl">
                        power
                    </mat-icon>
                    <mat-icon
                        [class.st-live-card-item-container__mobile--info--approved]="data()?.MOSAir"
                        [class.material-symbols-outlined]="!data()?.MOSAir">
                        stream
                    </mat-icon>
                </div>
            </div>
        </div>
    }
</ng-template>
<ng-template #largeCard>
    <!-- <div
        class="st-live-card-item-border-left"
        st-left-border
      [data]="data()"></div> -->
    <div class="st-live-card-item-container">
        <div class="st-live-card-item-container-info">
            <div class="st-live-card-item-container-info--rundown">{{ languageSettings()?.PSTObjectTypeRundown }}</div>
            @if (isArchived()) {
                <div class="st-live-card-item-container-info--archived">{{ archivedLabel() }}</div>
            }
            @if (this.isWastebin()) {
                <button
                    mat-icon-button
                    class="st-live-card-item-container-info__restore-btn"
                    st-click-stop-propagation
                    (click)="restoreContent.emit()">
                    <mat-icon class="material-symbols-outlined">history</mat-icon>
                </button>
            }
        </div>
        <div class="st-live-card-item-container-data">
            <div class="st-live-card-item-container-data__title">{{ data()?.Title }}</div>

            <div class="st-live-card-item-container-data-time">
                <div
                    class="st-live-card-item-container-data-time__start"
                    [matTooltip]="languageSettings()?.PSTWebStartsLabel">
                    @if (startTime() && startDate()) {
                        <span>{{ languageSettings()?.PSTWebStartsLabel }}: {{ startTime() }}</span>
                        <span>{{ startDate() }}</span>
                    } @else {
                        <span>{{ languageSettings()?.PSTWebNotAssignedOption }}</span>
                    }
                </div>
                <div
                    class="st-live-card-item-container-data-time__end"
                    [matTooltip]="languageSettings()?.PSTWebEndsLabel">
                    @if (endTime() && endDate()) {
                        <span>{{ languageSettings()?.PSTWebEndsLabel }}: {{ endTime() }}</span>
                        <span>{{ endDate() }}</span>
                    } @else {
                        <span>{{ languageSettings()?.PSTWebNotAssignedOption }}</span>
                    }
                </div>
            </div>
        </div>
        <div class="st-live-card-item-container__buttons">
            <button
                st-click-stop-propagation
                mat-icon-button
                [disabled]="!rundownEditable()"
                (click)="onAir()">
                <mat-icon
                    [matTooltip]="languageSettings()?.PSTRundownMenuProductionPutOnAir"
                    [class.st-live-card-item-container__buttons--approved]="data()?.OnAir"
                    [class.material-symbols-outlined]="!data()?.OnAir">
                    movie
                </mat-icon>
            </button>
            <button
                st-click-stop-propagation
                mat-icon-button
                [disabled]="!rundownEditable()"
                (click)="mosControlActive()">
                <mat-icon
                    [matTooltip]="languageSettings()?.PSTRundownMenuProductionMOSControlActive"
                    [class.st-live-card-item-container__buttons--approved]="data()?.MosControl"
                    [class.material-symbols-outlined]="!data()?.MosControl">
                    power
                </mat-icon>
            </button>

            <button
                st-click-stop-propagation
                mat-icon-button
                [disabled]="!rundownEditable()"
                (click)="mosReadyToAir()">
                <mat-icon
                    [matTooltip]="languageSettings()?.PSTRundownMenuProductionMOSReadyToAir"
                    [class.st-live-card-item-container__buttons--approved]="data()?.MOSAir"
                    [class.material-symbols-outlined]="!data()?.MOSAir">
                    stream
                </mat-icon>
            </button>
            @if (this.isTemplates()) {
                <button
                    st-click-stop-propagation
                    mat-icon-button
                    [disabled]="!rundownEditable()"
                    (click)="rundownOpenEmitter.emit()">
                    <mat-icon [matTooltip]="displayOpenActionButtonHoverTitle()">fullscreen</mat-icon>
                </button>
            }
        </div>
    </div>
</ng-template>
